<template>
    		<!-- /Ads-banner-section start -->
		<section class="advertisement-section advertisement-section-eight">
			<div class="container">
				<div class="row">
					<div class="col-lg-4 col-md-6 aos" data-aos="fade-up">
						<div class="left-ads">
							<div class="ads-img">
								<img src="@/assets/img/ads-banner.png" class="img-fluid" alt="image">
							</div>
						</div>
					</div>
					<div class="col-lg-8 col-md-6 d-flex align-items-center aos" data-aos="fade-up">
						<div class="right-ads">
							<div class="ads-content">
								<h1>Get Matched the Most Valuable Jobs, Just Drop Your Cv at Listee</h1>
								<p>Lorem Ipsum is simply dummy text printing and type setting industry printing and type
									setting industryLorem Ipsum is simply dummy text printing and type setting industry
									printing and type setting industry</p>

								<div class="advs-btn">
									<router-link to="contact">Upload your CV</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="ads-bg-right"></div>
		</section>
		<!-- /Ads-banner-section end -->
    </template>